/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CityService from "../../services/cityService";
import { Autocomplete, Box, Button, TextField, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { v4 as uuidv4 } from 'uuid';
import CustomInput from "../inputs/customInput";
import AddIcon from '@mui/icons-material/Add';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const CityPageListForm = ({ formValues, setFormValues, }) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [rtlPlugin],
    });

    const cacheLtr = createCache({
        key: 'ltr',
    });


    const [allCities, setAllCities] = useState([]);

    const fetchCities = async () => {
        try {
            const data = await CityService.fetchAll();
            setAllCities(data);
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };

    useEffect(() => {
        fetchCities();
    }, []);

    const handleCityChange = (index, newValue) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            prices: prevValues.prices.map((price, i) =>
                i === index
                    ? { ...price, cityId: newValue?.id || '', cityName: newValue?.name || '' }
                    : price
            ),
        }));
    };

    const handleSearchChange = (index, searchValue) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            prices: prevValues.prices.map((price, i) =>
                i === index
                    ? { ...price, searchQuery: searchValue }
                    : price
            ),
        }));
    };

    const addPrice = () => {
        setFormValues((prevValues) => ({
            ...prevValues,
            prices: [
                ...prevValues.prices,
                {
                    id: uuidv4(),
                    cityId: '',
                    cityName: '',
                    transportationPrice: '',
                    searchQuery: '',
                    cityError: '',
                    transportationPriceError: '',
                },
            ],
        }));
    };

    const removePrice = (id) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            prices: prevValues.prices.filter((item) => item.id !== id),
        }));
    };

    return (
        <Box>
            <Button variant="text" sx={{
                display: 'inline-flex',
                alignItems: 'center',
                cursor: 'pointer'
            }}
                onClick={addPrice}
            >
                <p
                    style={{
                        color: theme.palette.text.primary,
                        fontSize: 14,
                    }}
                >
                    {t('addPrice')}
                </p>
                <AddIcon fontSize="small" sx={{ mx: 0.4 }} />
            </Button >
            {formValues.prices.map((price, index) => {

                const filteredCities = allCities.filter((city) =>
                    city.name.toLowerCase().includes(price.searchQuery?.toLowerCase() || "")
                );

                return <Box key={price.id} display={isTablet ? 'unset' : 'flex'} justifyContent={'space-between'}>
                    <Box sx={{ display: 'flex' }} width={isTablet ? '100%' : '32%'}>
                        <Box width={isTablet ? '90%' : '100%'}>
                            <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
                                <Autocomplete
                                    options={filteredCities}
                                    getOptionLabel={(option) => option.name}
                                    value={
                                        allCities.find((city) => city.id === price.cityId) || null
                                    }
                                    onChange={(event, newValue) => handleCityChange(index, newValue)}
                                    onInputChange={(event, newInputValue) =>
                                        handleSearchChange(index, newInputValue)
                                    }
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                            {option.name}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <Box>
                                            <p
                                                style={{
                                                    color: theme.palette.text.primary,
                                                    fontSize: 13,
                                                    marginTop: 24,
                                                    marginBottom: 4,
                                                }}
                                            >
                                                {t("city")}
                                            </p>


                                            <TextField
                                                {...params}
                                                variant={'outlined'}
                                                fullWidth
                                                placeholder={t('chooseCity')}
                                                error={!!price.cityError}
                                                helperText={price.cityError}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                    style: {
                                                        backgroundColor: theme.palette.customGrey.insideInput,
                                                        padding: '6px 8px',
                                                    },
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: theme.palette.customGrey.borderInput,
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: theme.palette.customGrey.borderInput,
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: theme.palette.primary.main,
                                                        },
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        color: theme.palette.text.primary,
                                                        padding: '6px 8px',
                                                        '&::placeholder': {
                                                            fontSize: '14px',
                                                            color: theme.palette.text.secondary,
                                                            opacity: 1,
                                                        },
                                                    },
                                                }}
                                            />
                                        </Box>
                                    )}
                                />
                            </CacheProvider>
                        </Box>
                        {
                            isTablet && <Box width={'10%'}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    mt: 3
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyItems: 'center',
                                        color: theme.palette.text.red,
                                        cursor: 'pointer',
                                    }}>
                                    <CloseOutlinedIcon onClick={() => removePrice(price.id)} />
                                </Box>
                            </Box>
                        }
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'}>
                        <CustomInput
                            label={t('transportationPrice')}
                            placeholder={t('transportationPriceHere')}
                            name={`transportationPrice${index}`}
                            type='text'
                            value={price.transportationPrice ? Number(price.transportationPrice).toLocaleString() : 0}
                            onChange={(e) =>
                                setFormValues((prevValues) => ({
                                    ...prevValues,
                                    prices: prevValues.prices.map((p, i) =>
                                        i === index
                                            ? { ...p, transportationPrice: e.target.value.replace(/,/g, "") }
                                            : p
                                    ),
                                }))
                            }
                            error={!!price.transportationPriceError}
                            helperText={price.transportationPriceError}
                        />
                    </Box>
                    {
                        !isTablet && <Box width={'32%'}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyItems: 'center',
                                    color: theme.palette.text.red,
                                    cursor: 'pointer',
                                }}>
                                <CloseOutlinedIcon onClick={() => removePrice(price.id)} />
                            </Box>
                        </Box>
                    }

                </Box>
            })}
        </Box>
    );
}

export default CityPageListForm;